var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTwitterX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38.905,
    viewBox: "0 0 38 38.905",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #002c5f;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18766",
    "data-name": "Group 18766",
    transform: "translate(-1500 -8099)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18399",
    "data-name": "Rectangle 18399",
    className: "cls-1",
    width: 38,
    height: 38.905,
    rx: 6,
    transform: "translate(1500 8099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7560",
    "data-name": "Path 7560",
    className: "cls-2",
    d: "M45.892,45.074,41.276,38.93l.591-.628c.334-.334,2.008-2.142,3.719-4s3.311-3.6,3.559-3.853l.431-.457H47.569l-3.533,3.816c-1.934,2.094-3.57,3.816-3.619,3.816s-1.38-1.722-2.953-3.816L34.607,29.99H31.233c-1.859,0-3.373.011-3.373.037S29.831,32.7,32.23,35.9s4.359,5.884,4.345,5.936S34.581,44.026,32.2,46.6s-4.345,4.716-4.345,4.753a3.6,3.6,0,0,0,.96.063h.948l3.756-4.076c2.068-2.239,3.816-4.125,3.89-4.187.1-.074,1.108,1.168,3.262,4.062L43.8,51.4l3.362.011a27.549,27.549,0,0,0,3.351-.1c0-.051-2.079-2.856-4.616-6.244Zm.16,4.864-1.514-.011-6.772-9.063c-3.719-4.973-6.821-9.135-6.87-9.22h0c-.086-.149.171-.171,1.44-.171h1.525l6.821,9.112c3.742,5.01,6.832,9.172,6.844,9.235s-.543.123-1.477.123Z",
    transform: "translate(1479.695 8077.576)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitterX);
export default __webpack_public_path__ + "static/media/Icon_Twitter-X.5975e91636df27dce366c9ea23fee423.svg";
export { ForwardRef as ReactComponent };